<template>
  <div class="homePage">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <!-- Start Main Loader -->
    <transition name="fadeInUp" mode="out-in" v-if="loading">
      <MainLoader />
    </transition>
    <!-- End Main Loader -->
    <div
      v-if="data"
      class="tw-container-fluid grid_template tw-grid tw-grid-cols-2 md:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-3"
    >
      <div
        class="div_wrapper tw-items-start tw-rounded-lg tw-py-4 tw-px-3 tw-flex tw-gap-2 tw-bg-[#e5f6ff] tw-transition tw-duration-300"
        v-for="(item, index) in data.statistical"
        :key="index"
      >
        <div class="tw-flex-1">
          <h3 class="tw-text-text tw-font-bold tw-text-2xl">
            {{ item.count }}
          </h3>
          <p class="tw-text-base tw-text-text">{{ item.name }}</p>
        </div>
        <i
          class="tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-justify-center tw-items-center tw-bg-[#b8e5ff] tw-transition tw-duration-300"
          :class="item.icon"
        ></i>
      </div>
      <div class="chart_section">
        <ColumnChart
          dir="ltr"
          type="bar"
          :ChartLabels="data.stats.projects_services_solutions_chart.labels"
          :ChartData="data.stats.projects_services_solutions_chart.series"
        >
          <template #chart_title>
            <span class="title_text"> </span>
          </template>
        </ColumnChart>
      </div>
    </div>

    <div class="tw-container-fluid tw-mt-6">
      <div
        class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-3"
        v-if="data"
      >
        <div class="tw-col-span-3 lg:tw-col-span-2">
          <ColumnChart
            dir="ltr"
            type="line"
            :ChartLabels="data.stats.blogs_chart.labels"
            :ChartData="data.stats.blogs_chart.series"
          >
            <template #chart_title>
              <span class="tw-text-primary" dir="rtl"> المقالات </span>
            </template>
          </ColumnChart>
        </div>
        <div class="tw-col-span-3 lg:tw-col-span-1">
          <h5 class="tw-text-primary">المقالات الاكثر مشاهدة</h5>
          <div class="tw-max-h-[350px] tw-overflow-y-auto tw-mb-4">
            <div
              v-for="(item, index) in data.blogs_most_visited"
              :key="index"
              class="tw-border-b tw-border-solid tw-mb-2 last:tw-mb-0 last:tw-border-0 tw-p2-4"
            >
              <h5 class="tw-text-text tw-text-lg tw-leading-3">
                {{ item.title }}
              </h5>
              <p class="tw-text-sm mt-2">
                {{ "مشاهدات" + " " + item.views }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Start:: Importing Charts
import SparksAreaCharts from "@/components/Charts/SparksAreaCharts.vue";
import AreaCharts from "@/components/Charts/AreaCharts.vue";
import ColumnChart from "@/components/Charts/ColumnChart.vue";
import DonutChart from "@/components/Charts/DonutChart.vue";
import LineChart from "@/components/Charts/LineChart.vue";
import RadialChart from "@/components/Charts/RadialChart.vue";
// End:: Importing Charts

// Start:: Statistics Tables
import UsersStatisticsTable from "@/components/StatisticsTables/UsersStatisticsTable.vue";
import TransfersTable from "@/components/StatisticsTables/TransfersStatisticsTable.vue";

import HomeCard from "@/components/StatisticsTables/HomeCard.vue";
import ReviewCard from "@/components/StatisticsTables/ReviewCard.vue";
import NotificationCard from "@/components/StatisticsTables/NotificationCard.vue";
import StockTrackCard from "@/components/StatisticsTables/StockTracking.vue";
// End:: Statistics Tables

// Start::

export default {
  name: "HomePage",

  components: {
    SparksAreaCharts,
    AreaCharts,
    ColumnChart,
    RadialChart,
    DonutChart,
    LineChart,
    UsersStatisticsTable,

    HomeCard,
    ReviewCard,
    NotificationCard,
    StockTrackCard,
    TransfersTable,
  },

  data() {
    return {
      // ========== Charts Aside
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
      ],
      labels: [
        "2022-04",
        "2022-05",
        "2022-06",
        "2022-07",
        "2022-08",
        "2022-09",
        "2022-10",
        "2022-11",
        "2022-12",
        "2023-01",
        "2023-02",
        "2023-03",
      ],
      series: [
        {
          name: "all services",
          type: "column",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 58, 44.78125, 0],
        },
        {
          name: "all solutions",
          type: "column",
          data: [7, 0, 0, 0, 0, 0, 0, 45, 0, 58, 44.78125, 0],
        },
        {
          name: "all Projects",
          type: "column",
          data: [0, 0, 4, 0, 0, 10, 0, 0, 0, 58, 44.78125, 0],
        },
      ],
      // ========== Charts Aside
      asideIsActive: false,
      data: null,
      randomColors: [],
      // ============ Charts Data
      recent_orders: [],
      notifications: [],
      recent_reviews: [],
      top_product: [],
      upper_chart: [],
      products_out_of_stock: [],
      transfer_requests: [],
      chartsRev: [],
      chartsTopSell: [],
      chartsOrderStatus: [],
      tables: null,
      hashtags: null,
      loading: false,
      orders: [
        {
          id: 1,
          date: "12-11-1994",
          customer: {
            id: 1,
            name: "diaa",
          },
          price: 200,
          status: "pendding",
          paid: 1,
        },
        {
          id: 2,
          date: "12-11-1994",
          customer: {
            id: 1,
            name: "diaa",
          },
          price: 200,
          status: "inprogress",
          paid: 0,
        },
        {
          id: 2,
          date: "12-11-1994",
          customer: {
            id: 1,
            name: "diaa",
          },
          price: 200,
          status: "inprogress",
          paid: 0,
        },
      ],
    };
  },

  computed: {
    user() {
      return this.$store.getters["auth_module/currentUser"];
    },
  },

  methods: {
    getStatistcsData() {
      this.canShow = this.$permission.allowed("home/show");
      if (!this.canShow) {
        this.loading = true;
        this.axios({
          method: "GET",
          url: "stats",
          params: { internal: 1 },
        })
          .then((res) => {
            this.data = res.data.data;
            this.generateRandomColor();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getPermissions() {
      this.axios
        .get("get_my_permissions", { params: { internal: 1 } })
        .then((res) => {
          localStorage.setItem(
            "alamiya_permissions",
            JSON.stringify(res.data.data)
          );
          this.getStatistcsData();
          this.getSideBar();
        });
    },
    getControls() {
      this.axios
        .get("get_my_control_permissions", { params: { internal: 1 } })
        .then((res) =>
          localStorage.setItem(
            "alamiya_controls",
            JSON.stringify(res.data.data)
          )
        );
    },
    getSideBar() {
      this.axios
        .get("admin_side_bar", { params: { internal: 1 } })
        .then((res) => {
          this.$router.push(`/${res.data[0].categories[0].permissions[0].url}`);
        });
    },
    generateRandomColor() {
      for (let i = 0; i < this.cards.length; i++) {
        const random = () => Math.floor(256 * Math.random());
        this.randomColors.push(`rgb(${random()}, ${random()}, ${random()})`);
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.dispatchEvent(new Event("resize"));
    });
  },

  created() {
    // this.getStatistcsData()
    if (this.user.usertype != "superadmin") {
      this.getPermissions();
      this.getControls();
    } else {
      if (localStorage.getItem("alamiya_controls")) {
        localStorage.removeItem("alamiya_controls");
      }
      if (localStorage.getItem("alamiya_permissions")) {
        localStorage.removeItem("alamiya_permissions");
      }
      this.getStatistcsData();
    }
  },
};
</script>
<style lang="scss" scoped>
.grid_template {
  .chart_section {
    grid-row-start: 1;
    grid-column-start: 1;
    grid-row-end: 5;
    grid-column-end: 3;
    @media (min-width: 992px) {
      grid-column-end: 4;
    }
  }
}
.div_wrapper:hover {
  @include midShadow;
  i {
    transform: scale(1.1);
  }
}
.blogs_side {
  .single_blog {
    @include midShadow;
    padding: 15px 12px;
    margin-block: 15px;
    border-radius: 10px;
    @include flexSpaceBetweenAlignment;
    p {
    }
    span {
      font-weight: 700;
      font-size: 27px;
      color: var(--mainColor-2);
    }
  }
}
.v-icon.v-icon {
  color: var(--mainColor-2);
}
</style>
